module.exports = __webpack_public_path__ + "static/media/sn.d488be6f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/sn.svg
// module id = 250
// module chunks = 0